import { z } from 'zod';

import {
  BackgroundColor,
  BehaviorSettings,
  BlockAlignStyle,
  BorderColor,
  CmsImage,
  CmsUrl,
  ImageLoadingMethod,
  ImageOverlayStyle,
  ImageSizeStyle,
  PaddingStyle,
  VisibilitySettingStyle,
} from '../models';
import { BasePType } from './base';

export const InlineImage = BasePType.extend({
  type: z.enum(['inlineImage']),
  topLeft: z.boolean().optional(),
  analyticsLinkText: z.string().nullable(),
  blockAlign: z.nullable(BlockAlignStyle),
  borderColor: z.nullable(BorderColor).optional(),
  borderWidth: z.string().nullable().optional(),
  class: z.string().nullable(),
  endOpacityPercent: z.string().nullable(),
  endOpacityPercentMobile: z.string().nullable(),
  endPositionPercent: z.string().nullable(),
  endPositionPercentMobil: z.string().nullable(),
  gradientBackgroundColor: z.nullable(BackgroundColor),
  gradientDirection: z.string().nullable(),
  gradientDirectionMobile: z.string().nullable(),
  imageHeight: z.number().nullable(),
  imageOverlayColor: z.nullable(BackgroundColor),
  imageOverlayStyle: z.nullable(ImageOverlayStyle),
  imageSize: z.nullable(ImageSizeStyle),
  imageSizeMidrange: z.nullable(ImageSizeStyle),
  imageSizeMobile: z.nullable(ImageSizeStyle),
  imageWidth: z.number().nullable(),
  loading: z.nullable(ImageLoadingMethod),
  padding: z.nullable(PaddingStyle),
  paddingHorizontal: z.nullable(PaddingStyle),
  paddingVertical: z.nullable(PaddingStyle),
  paddingBottom: z.nullable(PaddingStyle),
  paddingLeft: z.nullable(PaddingStyle),
  paddingRight: z.nullable(PaddingStyle),
  paddingTop: z.nullable(PaddingStyle),
  roundedCornerRadius: z.string().nullable(),
  startOpacityPercent: z.string().nullable(),
  startOpacityPercentMobi: z.string().nullable(),
  startPositionPercent: z.string().nullable(),
  startPositionPercentMob: z.string().nullable(),
  url: z.nullable(CmsUrl),
  visibilitySetting: z.nullable(VisibilitySettingStyle),
  webpMedia: z.nullable(CmsImage),
  webpMediaMid: z.nullable(CmsImage),
  webpMediaDesktop: z.nullable(CmsImage),
  behaviorSettings: z.nullable(BehaviorSettings),
});

export type InlineImage = z.infer<typeof InlineImage>;
